<template>
    <div class="favorite_button" :class="id" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction">
        <div class="favorite">
            <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31 27" style="enable-background:new 0 0 31 27;" xml:space="preserve">
                <path @click.stop="click" class="favorite_path" :class="{clicked: photo_data.favorite_list.length}" d="M15.5,26.5c-0.43,0-0.84-0.15-1.16-0.42c-1.21-1.03-2.38-2-3.41-2.86l-0.01,0C7.9,20.7,5.29,18.54,3.48,16.4
                C1.45,14.02,0.5,11.75,0.5,9.28c0-2.4,0.85-4.62,2.38-6.24c1.55-1.64,3.68-2.54,6-2.54c1.73,0,3.32,0.53,4.71,1.59
                c0.7,0.53,1.34,1.18,1.91,1.94c0.56-0.76,1.2-1.41,1.91-1.94c1.4-1.05,2.98-1.59,4.71-1.59c2.32,0,4.45,0.9,6,2.54
                c1.53,1.62,2.38,3.84,2.38,6.24c0,2.47-0.95,4.73-2.98,7.12c-1.82,2.13-4.43,4.3-7.45,6.81c-1.03,0.86-2.2,1.83-3.42,2.86
                C16.34,26.35,15.93,26.5,15.5,26.5z"/>
            </svg>
        </div>
        <div class="hover_sukikamo pc" v-if="hoverFlag && !clicked"><img src="../assets/images/hover_sukikamo.svg" alt="すきカモリストに追加する?"></div>

        <div v-if="!is_sp">
            <AddSukikamoList
                    class="sukikamo_list"
                    v-if="clicked"
                    @close="clicked = false"
                    :photo_data="photo_data"
            />
        </div>
        <div v-else>
            <modal :name="`favorite_modal_${id}`" width="250" height="auto" @closed="clicked = false">
                <AddSukikamoList
                        class="sukikamo_list"
                        v-if="clicked"
                        @close="clicked = false"
                        :photo_data="photo_data"
                />
            </modal>
        </div>

        <modal :name="`favorite_login_modal_${id}`"  :maxWidth="600" width="90%" :adaptive="true">
            <div class="caution">お気に入り機能をご利用いただくには<br class="sp">ログインが必要です。</div>
        </modal>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { v4 as uuidv4 } from 'uuid'
    import AddSukikamoList from './AddSukikamoList'

    export default {
        name: "FavoriteButton",
        components: { AddSukikamoList },
        props: {
            photo_data: Object
        },
        data: () => ({
            id: `id_${uuidv4()}`,
            clicked: false,
            hoverFlag: false,
        }),
        computed: {
            ...mapState(["is_sp", "user_data"])
        },
        watch: {
            is_sp() {
                this.clicked = false;
                this.$modal.hide(`favorite_modal_${this.id}`);
            },
            clicked() {
                if ( !(this.is_sp && this.clicked) ) return;
                this.$modal.show(`favorite_modal_${this.id}`);
            }
        },
        methods: {
            click() {
                if ( this.user_data.id === -1 ) return this.$modal.show(`favorite_login_modal_${this.id}`);
                this.clicked = true;
            },
            mouseOverAction(){
                this.hoverFlag = true
            },
            mouseLeaveAction(){
                this.hoverFlag = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .favorite_path{
        fill-rule:evenodd;
        clip-rule:evenodd;
        fill:#FFFFFF;
        fill-opacity:0.85;
        stroke:#816E66;
        stroke-miterlimit:10;
        &:hover{
            cursor: pointer;
            opacity: 0.8;
        }
        &.clicked{
            fill:#E68A8A;
            fill-opacity:1;
        }
    }

    .favorite_button{
        position: relative;
        svg{
            width: 24px;
            height: 24px;
            vertical-align: middle;
        }
        .hover_sukikamo {
            position: absolute;
            top: -110px;
            right: -88px;
            width: 166px;
        }
        .sukikamo_list{
            position: absolute;
            bottom: -10px;
            left: -60px;
            transform: translate(-50%, 100%);
        }
    }

    .caution{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media screen and (max-width:639px) {
        .favorite_button{
            .sukikamo_list{
                position: static;
                transform: translate(0, 0);
            }
        }
    }
</style>
